import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconSurfaceFloor.tsx
const IconSurfaceFloor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#d0c6c3",
			d: "m14.98 10.854-.021.146a3.04 3.04 0 0 1-.877 1.662L21 16.635l1-1.732zM9.021 10.854l.021.146c.108.643.43 1.227.877 1.662L3 16.635l-1-1.732z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#d0c6c3",
			fillRule: "evenodd",
			d: "M15 10.501a3 3 0 0 0-2-2.83l-.004-5.257h-2L11 7.672a3.001 3.001 0 1 0 3.082 4.99 3.04 3.04 0 0 0 .898-1.808q.02-.173.02-.353m-4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4.72 17.638 12 21.59l7.28-3.952-4.843-2.77A5 5 0 0 1 12 15.5c-.885 0-1.715-.23-2.435-.633z"
		})
	]
});
var IconSurfaceFloor_default = forwardRef(IconSurfaceFloor);
//#endregion
export { IconSurfaceFloor_default as default };
